import { render } from "./EditLocationSideNav.vue?vue&type=template&id=23715afc"
import script from "./EditLocationSideNav.vue?vue&type=script&lang=js"
export * from "./EditLocationSideNav.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__